var render = function render(){var _vm=this,_c=_vm._self._c;return _c('productProgress',{attrs:{"title":"产品主页"}})
}
var staticRenderFns = []

export { render, staticRenderFns }